module.exports = __webpack_public_path__ + "static/media/test1 (11).d58ad3ff.jpg";